var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('h3',[_vm._v("Kunden - CRM Historie")]),_c('b-table',{staticClass:"mt-3",attrs:{"striped":"","hover":"","fields":_vm.fields,"items":_vm.rows}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }